// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"41cdba3d","497":"a828ad4a"}[chunkId] + ".chunk.css";
};